import { PortalModule } from '@angular/cdk/portal';
import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { AppBusyStateComponentDef } from '@df/ui/display/busy-state/app-busy-state.component.def';

@Component({
    selector: 'app-busy-state',
    templateUrl: './app-busy-state.html',
    styleUrl: './app-busy-state.scss',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [PortalModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppBusyStateComponent extends AppBusyStateComponentDef {}
